import { assetManagementState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { config } from "config";

const initialState: assetManagementState = {
  handoverData: [],
  handoverCount: 0,
  handoverFilters: { page: 1, page_size: config.PAGE_SIZE || 10 },
  handoverRefresh: 0,
  handoverRefreshLoader: false,
  assetListingData: [],
  filters: { page: 1, page_size: config.PAGE_SIZE || 10 },
  count: 0,
  refresh: 0,
  refreshLoader: false,
  current_filters: {},
  assetCategories: [],
  currentAsset: null,
  eCarsListingData: [],
  eCarsCount: 0,
  eCarsFilters: { page: 1, page_size: config.PAGE_SIZE || 10 },
  eCarsRefresh: 0,
  eCarsRefreshLoader: false,
  currentECar: null,
  loading: true,
};

export const assetManagementSlice = createSlice({
  name: "assetManagement",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setHandoverData: (state, action) => {
      const { handoverData, count } = action.payload || {};
      state.handoverData = handoverData || [];
      state.handoverCount = count || 0;
      state.handoverRefreshLoader = false;
    },
    setHandoverPage: (state, action: PayloadAction<number>) => {
      state.handoverRefresh = (state.handoverRefresh || 0) + 1;
      state.handoverRefreshLoader = true;
      if (state.handoverFilters) {
        state.handoverFilters.page = action.payload;
      }
    },
    resetHandoverPage: (state) => {
      if (state.handoverFilters) {
        state.handoverFilters.page = 1;
      }
    },
    refreshHandover: (state) => {
      state.handoverRefresh = (state.handoverRefresh || 0) + 1;
      state.handoverRefreshLoader = true;
    },
    // Asset Listing
    setAssetListingData: (state, action) => {
      const { assetListingData, count } = action.payload || {};
      state.assetListingData = assetListingData || [];
      state.count = count || 0;
      state.refreshLoader = false;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh = (state.refresh || 0) + 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    refresh: (state) => {
      state.refresh = (state.refresh || 0) + 1;
      state.refreshLoader = true;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    // Asset Categories
    setAssetCategories: (state, action) => {
      state.assetCategories = action.payload || [];
    },
    // Current Asset
    setCurrentAsset: (state, action) => {
      state.currentAsset = action.payload;
    },
    // E Cars Listing
    setECarsListingData: (state, action) => {
      const { eCarsListingData, count } = action.payload || {};
      state.eCarsListingData = eCarsListingData || [];
      state.eCarsCount = count || 0;
      state.eCarsRefreshLoader = false;
    },
    setECarsPage: (state, action: PayloadAction<number>) => {
      state.eCarsRefresh = (state.eCarsRefresh || 0) + 1;
      state.eCarsRefreshLoader = true;
      state.eCarsFilters.page = action.payload;
    },
    resetECarsPage: (state) => {
      state.eCarsFilters.page = 1;
    },
    refreshECars: (state) => {
      state.eCarsRefresh = (state.eCarsRefresh || 0) + 1;
      state.eCarsRefreshLoader = true;
    },
    setECarsFilters: (state, action) => {
      state.eCarsFilters = action.payload;
      state.eCarsRefreshLoader = true;
    },
    resetECarsFilters: (state) => {
      state.eCarsRefresh = (state.eCarsRefresh || 0) + 1;
      state.eCarsRefreshLoader = true;
      state.eCarsFilters = initialState.eCarsFilters;
    },
    // Current E Car
    setCurrentECar: (state, action) => {
      state.currentECar = action.payload;
    },
  },
});

export const assetManagementReducer = assetManagementSlice.reducer;

export const assetManagementActions = assetManagementSlice.actions;

